import {Component, inject, OnInit} from '@angular/core';
import {Movie} from '../../../models/vision/movie';
import {RestApiService} from '../../../services/api/rest-api.service';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {MovieSelectorComponent} from '../../../components/movie-selector/movie-selector.component';
import {ButtonModule} from 'primeng/button';
import {OrderListModule} from 'primeng/orderlist';
import {ToastModule} from 'primeng/toast';
import {ConfirmationService, MessageService} from 'primeng/api';
import {CommonModule} from '@angular/common';
import {ToastService} from '../../../services/toast.service';
import {ActionButtonComponent} from '../../../components/form/action-buttons/action-button.component';
import {BlockableDivComponent} from '../../../components/form/blockable-div/blockable-div.component';
import {BlockUI} from 'primeng/blockui';

@Component({
  selector: 'app-slider-manager',
  imports: [
    DropdownModule,
    FormsModule,
    ButtonModule,
    OrderListModule,
    ToastModule,
    CommonModule,
    MovieSelectorComponent,
    ActionButtonComponent,
    BlockableDivComponent,
    BlockUI
  ],
  providers: [MessageService],
  templateUrl: './slider-manager.component.html',
  styleUrl: './slider-manager.component.css'
})
export class SliderManagerComponent implements OnInit {
  api = inject(RestApiService);
  toastService = inject(ToastService);
  messageService = inject(MessageService);
  confirm = inject(ConfirmationService);
  selectedMovies: Movie[] = [];
  maxMovies = 5;
  loadingData = false;
  loading = false;

  ngOnInit() {
    this.loadSelectedMovies();
  }

  async loadSelectedMovies() {
    try {
      this.loading = true;
      const response = await this.api.carousel.getCarouselMovies();
      this.selectedMovies = response.data;
      this.selectedMovies.sort((a, b) => a.sliderSequence! - b.sliderSequence!);
    } finally {
      this.loading = false;
    }
  }

  obj(item: Movie) {
    return item;
  }

  async onMovieSelected(movieId: number) {
    if (movieId) {
      if (this.selectedMovies.some(m => m.movieId === movieId)) {
        this.toastService.warning('Attenzione', 'Questo film è già stato selezionato.');
        return;
      }
      if (this.selectedMovies.length >= this.maxMovies) {
        this.toastService.error('Attenzione', `Puoi selezionare al massimo ${this.maxMovies} film.`);
        return;
      }

      try {
        this.loadingData = true;
        const movieWithImages = await this.api.movies.byId(movieId);
        this.selectedMovies.push(movieWithImages.data);
        this.onMoviesReordered();
      } finally {
        this.loadingData = false;
      }
    }
  }

  onDelete(movie: Movie) {
    // confirm deletion
    this.confirm.confirm({
      header: 'Conferma eliminazione',
      message: `Sei sicuro di voler rimuovere "${movie.title}" dalla lista?`,
      acceptIcon: 'pi pi-trash',
      acceptLabel: 'Rimuovi',
      rejectIcon: 'pi pi-times',
      rejectLabel: 'Annulla',
      rejectButtonStyleClass: 'btn-secondary p-button-text',
      accept: async () => {
        this.selectedMovies = this.selectedMovies.filter(m => m.movieId !== movie.movieId);
        this.toastService.success('Film rimosso', `"${movie.title}" è stato rimosso dalla lista.`);
      },
      reject: () => {
        this.toastService.info('Operazione annullata', 'Nessun film è stato rimosso dalla lista.');
      }
    });
  }

  onEdit(movie: Movie) {
    // redirect to edit page
    window.open(`/movies/${movie.movieId}`, '_self');
  }

  onMoviesReordered() {
    this.selectedMovies.forEach((movie, index) => {
      movie.sliderSequence = index + 1;
    });
  }

  async save() {
    try {
      this.loading = true;
      await this.api.carousel.saveCarouselSequence(this.selectedMovies.map(x => x.movieId));
      this.toastService.success('Successo', 'Sequenza del carosello salvata con successo.');
    } finally {
      this.loading = false;
    }
  }
}
